import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const Icon = styled.img`
  width: 30%;
  height: 30%;
  object-fit: contain;
`;

export const Description = styled.p`
  font-family: 'Russo One';
  font-weight: 400;
  line-weight: 38px;
  font-size: 24px;
  text-align: center;
  margin-top: 5%;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-top: 2%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5%;
  margin-top: 5%;
`;
